<template>
	<div
		class="fixed top-0 z-[1000] flex h-14 w-full items-center justify-center gap-1 bg-gradient-to-r from-[#0076BB] to-[#1C94DA] px-2 sm:px-8 md:h-8"
	>
		<span class="text-center text-base font-medium text-white">
			<IcoBell class="-mt-1 mr-1 inline h-4 w-4 fill-white" />
			QLD office is moving to a new location soon!
			<br class="md:hidden" />
			<CarbarLink
				href="/brisbane"
				text="Find out more"
				class="inline-block"
				font-size="text-base"
				font-weight="font-medium"
				text-color="text-white hover:text-gray-100"
				underline-color="underline-white hover:decoration-gray-100"
			/>
		</span>
	</div>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import IcoBell from '@/assets/svg/common/ico-bell.svg'
</script>
